import React from 'react';
import { Pressable, StyleSheet, Text } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { COLORS } from '../config/colors';
import { FONTS } from '../config/fonts';
import { useIsHorizontal } from '../hooks/useIsHorizontal';
import { strings } from '../strings';
import SearchIcon from './icons/SearchIcon';

type SearchBarProps = {
  onPress: () => void;
};

const SearchBar = ({ onPress }: SearchBarProps) => {
  const insets = useSafeAreaInsets();
  const isHorizontal = useIsHorizontal();

  return (
    <Pressable
      accessibilityLabel={strings.searchStations}
      accessibilityHint={strings.searchStationsHint}
      accessibilityRole="button"
      onPress={onPress}
      style={({ pressed }) => [
        styles.searchBar,
        { bottom: insets.bottom + 12 },
        // Horizontal mode docks the bar to the left instead of centering it.
        isHorizontal && styles.searchBarHorizontal,
        pressed && styles.searchBarPressed,
      ]}
    >
      <SearchIcon color={COLORS.ink} />
      <Text style={styles.placeholder}>{strings.searchStationsOrCities}</Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  // Same look as the floating buttons, adapted to a wider bar.
  searchBar: {
    direction: 'rtl',
    position: 'absolute',
    alignSelf: 'center',
    width: '95%',
    maxWidth: 500,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    backgroundColor: COLORS.surface,
    borderRadius: 15,
    paddingHorizontal: 16,
    paddingVertical: 12,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 4,
  },
  searchBarHorizontal: {
    alignSelf: 'flex-start',
    left: 16,
    width: '45%',
    maxWidth: 420,
  },
  searchBarPressed: {
    opacity: 0.8,
  },
  placeholder: {
    flex: 1,
    fontFamily: FONTS.regular,
    fontSize: 16,
    color: COLORS.ink,
  },
});

export default SearchBar;